import React, { useEffect, useState, useCallback } from 'react';
import { io } from 'socket.io-client';
import OverviewPanel from '../components/OverviewPanel';
import MapView from '../components/MapView';
import RightPanel from '../components/RightPanel';
import BottomBar from '../components/BottomBar';
import { fetchOverview, fetchAlerts, fetchMapData } from '../utils/api';
import './Dashboard.css';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

const Dashboard = () => {
  const [overview, setOverview] = useState(null);
  const [alertCounts, setAlertCounts] = useState(null);
  const [mapData, setMapData] = useState([]);

  const loadData = useCallback(async () => {
    try {
      const [ovRes, alRes, mapRes] = await Promise.allSettled([
        fetchOverview(),
        fetchAlerts(),
        fetchMapData(),
      ]);
      if (ovRes.status === 'fulfilled') setOverview(ovRes.value.data);
      if (alRes.status === 'fulfilled') setAlertCounts(alRes.value.data.counts);
      if (mapRes.status === 'fulfilled') setMapData(mapRes.value.data);
    } catch (e) {}
  }, []);

  useEffect(() => {
    loadData();
    // Polling every 5 seconds as backup
    const interval = setInterval(loadData, 5000);
    return () => clearInterval(interval);
  }, [loadData]);

  // Socket.IO — instant update when Arduino sends data
  useEffect(() => {
    const socket = io(SOCKET_URL);
    socket.on('connect', () => console.log('🔌 Socket connected'));
    socket.on('baton_update', () => {
      loadData(); // refresh everything instantly
    });
    socket.on('disconnect', () => console.log('🔌 Socket disconnected'));
    return () => socket.disconnect();
  }, [loadData]);

  const handleQuickAction = (action) => {
    switch (action) {
      case 'broadcast': alert('📢 Broadcast Message panel coming soon'); break;
      case 'alert': alert('⚠️ Send Alert panel coming soon'); break;
      case 'personnel': alert('👮 Deployment Roaster coming soon'); break;
      case 'sos': alert('🆘 Emergency Support activated'); break;
      default: break;
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-main">
        <OverviewPanel data={overview} alertCounts={alertCounts} />
        <div className="dashboard-center">
          <MapView mapData={mapData} />
          <BottomBar data={overview} />
        </div>
        <RightPanel data={overview} />
      </div>
    </div>
  );
};

export default Dashboard;
